import React from 'react'
import PropTypes from 'prop-types'
import { DRAWER_CARD_CLASS, DRAWER_CARD_TITLE_CLASS } from '../shared/styles'

const CARD_CLASS = `${DRAWER_CARD_CLASS} tw:gap-4`
const TEXTAREA_CLASS = 'tw:w-full tw:rounded-lg! tw:resize-none! tw:border tw:border-solid '
  + 'tw:border-gray-300 tw:bg-gray-50 tw:p-3 tw:text-sm tw:text-gray-900'

const PLACEHOLDER = 'Écrivez un commentaire interne...'
const MAX_LENGTH = 2000

const IssueCommentCard = ({ value, onChange }) => (
  <section className={CARD_CLASS}>
    <h3 className={DRAWER_CARD_TITLE_CLASS}>Commentaire</h3>
    <textarea
      aria-label="Commentaire interne"
      className={TEXTAREA_CLASS}
      maxLength={MAX_LENGTH}
      name="issue-comment"
      placeholder={PLACEHOLDER}
      rows={5}
      value={value}
      onChange={onChange}
    />
  </section>
)

IssueCommentCard.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
}

export default IssueCommentCard
